/*
 * Created Date: Wed, 9th Dec 2020, 18:35:14 pm
 * Author: Kristyna Fojtikova
 * Email: kristyna.fojtikova@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useCallback } from 'react';
import {
  Datagrid,
  List,
  TextField,
  NumberField,
  useTranslate,
  usePermissions,
  Title,
  useGetList,
  useRedirect,
} from 'react-admin';
import ListActions from './actions';
import { isProjectManager } from 'utils/roles';
import * as R from 'ramda';
import { useDispatch } from 'react-redux';
import { EmptyResource } from 'Layout';
import { PostPagination } from '../../Components/CustomPagination/pagination';
import ListFilters from './filters';
import { usePersistentOrganisation } from '../../Components/Contexts';

const SiteList = props => {
  const translate = useTranslate();
  const { permissions } = usePermissions();

  const redirect = useRedirect();
  const {
    persistentOrganisation,
    onSelectPersistentOrganisation,
  } = usePersistentOrganisation();

  const { total, loading, error } = useGetList('Organisation', {
    page: 1,
    perPage: 1,
  });
  const hasOrganisations = !loading && !error && total > 0;

  const EmptySitesCallback = useCallback(() => {
    const EmptySites = () => {
      const title = hasOrganisations
        ? 'resources.Site.emptyStateTitle'
        : 'resources.Site.emptyStateNoOrgTitle';
      const subtitle = hasOrganisations
        ? 'resources.Site.emptyStateSubtitle'
        : 'resources.Site.emptyStateNoOrgSubtitle';
      const buttonLabel = hasOrganisations
        ? 'createSite'
        : 'createOrganisation';
      const basePath = hasOrganisations ? props.basePath : '/Organisation';
      return (
        <EmptyResource
          title={title}
          subtitle={subtitle}
          buttonLabel={buttonLabel}
          basePath={basePath}
        />
      );
    };
    return EmptySites();
  }, [hasOrganisations, redirect]);

  return (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <List
        filterDefaultValues={
          persistentOrganisation.id
            ? {
                organisationId: persistentOrganisation.id,
              }
            : {}
        }
        empty={<EmptySitesCallback />}
        title={translate('resources.Project.name', { smart_count: 2 })}
        bulkActionButtons={false}
        filters={
          <ListFilters organisationFilter={onSelectPersistentOrganisation} />
        }
        perPage={25}
        pagination={<PostPagination />}
        exporter={false}
        actions={<ListActions />}
        {...props}
      >
        <Datagrid
          rowClick={(id, basePath, record) => {
            const orgId = R.path(['project', 'organisation', 'id'], record);
            const isManager = isProjectManager(permissions, orgId);
            return isManager
              ? {
                  pathname: `/Site/${record.id}`,
                  state: {
                    organisationId: orgId,
                  },
                }
              : null;
          }}
        >
          <TextField
            source="name"
            label={'resources.Site.fields.name'}
            sortable={false}
          />
          <TextField
            source="project.organisation.name"
            label="resources.Site.fields.organisation"
            sortable={false}
          />
          <NumberField
            source="project.name"
            label={'resources.Site.fields.project'}
            sortable={false}
          />
          <NumberField
            source="statistics.numberOfTowers"
            label={'resources.Site.fields.numberOfTowers'}
            sortable={false}
          />
        </Datagrid>
      </List>
    </>
  );
};
export default SiteList;
